import type promoId from "./id";

const promoEn: typeof promoId = {
	promo: {
		title: "Discount System",
		subtitle: "Manage customer promos & rewards",
		discount_system_status: "Discount System Status:",
		status_active: "Active",
		status_inactive: "Inactive",
		create_button: "Create Promo",
		table: {
			title: "Promo Data",
			empty_state: {
				title: "No promo data",
				description: "Please add a new promo.",
			},
			columns: {
				date: "Date",
				created_by: "Created By",
				ref_id: "Ref ID",
				name: "Name",
				type: "Reward Type",
				reward_amount: "Reward Amount",
				max_amount: "Max Amount",
				expired_at: "Expiration Date",
				status: "Status",
				action: "Action",
			},
			types: {
				discount: "Transaction Discount",
				free_product: "Free Product",
				discount_per_product: "Discount Per Product",
				cashback: "Cashback",
				loyalty: "Loyalty",
			},
			status: {
				active: "Active",
				inactive: "Inactive",
			},
			detail: "Detail",
		},
		cards: {
			transaction: {
				title: "Transaction Discount",
				description:
					"Customers get a price discount from product purchases with certain requirements.",
				example:
					"Example: Spend Rp 100,000 and get a 10% transaction discount worth Rp 10,000",
			},
			free_product: {
				title: "Free Product",
				description:
					"Customers get a free product if they buy certain items and meet certain requirements.",
				example: "Example: Buy 1 Nasi Goreng, get a free Es Jeruk",
			},
			per_product: {
				title: "Per Product Discount",
				description:
					"Customers get a price discount from specific product purchases with certain requirements.",
				example:
					"Example: Buy product A at Rp 10,000, quantity 2, get a 10% discount worth Rp 1,000 for product A",
			},
		},
		modal: {
			title: "Add Promo",
			fields: {
				name: "Promo Name",
				name_placeholder: "Promo Name",
				all_stores: "Applies to All Stores?",
				period_enabled: "Specific Period?",
				period_start: "Start Date",
				period_end: "End Date",
				min_transaction_enabled: "Minimum Transaction?",
				min_transaction_amount: "Minimum Transaction Amount",
				min_transaction_placeholder: "Minimum Amount",
				day_enabled: "Applies on Specific Days?",
				time_enabled: "Applies at Specific Times?",
				product_enabled: "Applies to Specific Products?",
				payment_method_enabled: "Applies to Specific Payment Methods?",
				reward_type: "Discount Type",
				reward_type_placeholder: "Select Discount Type",
				reward_type_fix: "Fixed Amount",
				reward_type_percent: "Percentage",
				nominal: "Discount Amount",
				nominal_placeholder: "Discount Amount",
				max_nominal: "Maximum Reward Amount",
				max_nominal_placeholder: "Maximum Reward Amount",
				expired: "Expiration Date",
				status: "Status",
				status_placeholder: "Select Status",
				status_active: "Active",
				status_inactive: "Inactive",
			},
			cancel: "Cancel",
			save: "Save",
		},
	},
};

export default promoEn;
